import * as React from "react";
import CircularProgress from "@mui/material/CircularProgress";
import Backdrop from "@mui/material/Backdrop";

export default function Loader() {
  return (
    <Backdrop
      sx={{ color: "#ffffff", zIndex: (theme) => theme.zIndex.drawer + 1000 }}
      open={true}
    >
      <CircularProgress
        color="error"
        // sx={{ position: "absolute", left: "50%", top: "50%" }}
      />
    </Backdrop>
    // <Box sx={{ display: "flex" }}>
    //   <CircularProgress
    //     sx={{ position: "absolute", left: "50%", top: "50%" }}
    //   />
    // </Box>
  );
}
